'use client';
import { useQuery } from '@tanstack/react-query';

type CurrentUser = {
  userId?: string;
  email?: string;
  name?: string;
  isLoading: boolean;
};

export function useCurrentUser(): CurrentUser {
  const { data, isLoading } = useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      if (typeof window !== 'undefined' && window.electronAPI?.auth) {
        const result = await window.electronAPI.auth.getProfile();
        if (result.success && result.profile) {
          return {
            userId: result.profile.sub,
            email: result.profile.email,
            name: result.profile.name,
          };
        }
      }
      return {
        userId: undefined,
        email: undefined,
        name: undefined,
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    ...(data || { userId: undefined, email: undefined, name: undefined }),
    isLoading,
  };
}
